import Attachment16 from '@carbon/icons-react/es/attachment/16';
import Calendar16 from '@carbon/icons-react/es/calendar/16';
import CheckboxChecked16 from '@carbon/icons-react/es/checkbox--checked/16';
import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import CurrencyDollar16 from '@carbon/icons-react/es/currency--dollar/16';
import Email16 from '@carbon/icons-react/es/email/16';
import Hashtag16 from '@carbon/icons-react/es/hashtag/16';
import Phone16 from '@carbon/icons-react/es/phone/16';
import RadioButtonChecked16 from '@carbon/icons-react/es/radio-button--checked/16';
import Star16 from '@carbon/icons-react/es/star/16';
import StringText16 from '@carbon/icons-react/es/string-text/16';
import TextAlignJustify16 from '@carbon/icons-react/es/text--align--justify/16';
import TextVerticalAlignment16 from '@carbon/icons-react/es/text--vertical-alignment/16';
import React from 'react';
import { FormQuestionGroup, FormQuestionType } from 'api/form/types';
import { ReactComponent as DropdownMultiSelect } from 'assets/svgs/dropdown-multi-select.svg';
import { ReactComponent as MultiChoiceGrid } from 'assets/svgs/multi-choice-grid.svg';
import { ReactComponent as SingleChoiceGrid } from 'assets/svgs/single-choice-grid.svg';

export interface DefaultFormQuestion {
  label: string;
  group: FormQuestionGroup;
  icon: React.ReactNode;
  value: FormQuestionType;
}

export const FormQuestionsList: DefaultFormQuestion[] = [
  {
    label: 'short_text',
    group: FormQuestionGroup.Text,
    icon: <StringText16 />,
    value: FormQuestionType.TextShort,
  },
  {
    label: 'long_text',
    group: FormQuestionGroup.Text,
    icon: <TextAlignJustify16 />,
    value: FormQuestionType.TextLong,
  },
  {
    label: 'statement',
    group: FormQuestionGroup.Text,
    icon: <TextVerticalAlignment16 />,
    value: FormQuestionType.TextStatement,
  },
  {
    label: 'radio',
    group: FormQuestionGroup.Choices,
    icon: <RadioButtonChecked16 />,
    value: FormQuestionType.ChoiceRadio,
  },
  {
    label: 'checkbox',
    group: FormQuestionGroup.Choices,
    icon: <CheckboxChecked16 />,
    value: FormQuestionType.ChoiceCheckbox,
  },
  {
    label: 'dropdown',
    group: FormQuestionGroup.Choices,
    icon: <ChevronDown16 />,
    value: FormQuestionType.ChoiceDropdown,
  },
  {
    label: 'dropdown_multiselect',
    group: FormQuestionGroup.Choices,
    icon: <DropdownMultiSelect />,
    value: FormQuestionType.ChoiceDropdownMultiselect,
  },
  {
    label: 'attachment',
    group: FormQuestionGroup.Attachment,
    icon: <Attachment16 />,
    value: FormQuestionType.Attachment,
  },
  {
    label: 'date',
    group: FormQuestionGroup.Date,
    icon: <Calendar16 />,
    value: FormQuestionType.Date,
  },
  {
    label: 'currency',
    group: FormQuestionGroup.Currency,
    icon: <CurrencyDollar16 />,
    value: FormQuestionType.Currency,
  },
  {
    label: 'phone',
    group: FormQuestionGroup.ContactInfo,
    icon: <Phone16 />,
    value: FormQuestionType.Phone,
  },
  {
    label: 'email',
    group: FormQuestionGroup.ContactInfo,
    icon: <Email16 />,
    value: FormQuestionType.Email,
  },
  {
    label: 'number',
    group: FormQuestionGroup.Number,
    icon: <Hashtag16 />,
    value: FormQuestionType.Number,
  },
  {
    label: 'star_rating',
    group: FormQuestionGroup.Rating,
    icon: <Star16 />,
    value: FormQuestionType.StarRating,
  },
  {
    label: 'multiple_choice_grid',
    group: FormQuestionGroup.Choices,
    icon: <MultiChoiceGrid />,
    value: FormQuestionType.MultipleChoiceGrid,
  },
  {
    label: 'tick_box_grid',
    group: FormQuestionGroup.Choices,
    icon: <SingleChoiceGrid />,
    value: FormQuestionType.CheckBoxGrid,
  },
];

export const RowQuestionType = [
  FormQuestionType.CheckBoxGrid,
  FormQuestionType.MultipleChoiceGrid,
];

export const ChoiceQuestionType = [
  FormQuestionType.ChoiceRadio,
  FormQuestionType.ChoiceCheckbox,
  FormQuestionType.ChoiceDropdown,
  FormQuestionType.ChoiceDropdownMultiselect,
  FormQuestionType.CheckBoxGrid,
  FormQuestionType.MultipleChoiceGrid,
];

export const DropdownQuestionType = [
  FormQuestionType.ChoiceDropdown,
  FormQuestionType.ChoiceDropdownMultiselect,
];

export const FormHeaderID = -1;

export const MaxBranchingDepth = 5;

export const StarRatingConfigValues = [3, 5, 7, 10];
export const DefaultCurrencyCode = '$';
